const setTitle = (title?: string) => {
  const siteName = 'Physio App';
  if (title) document.title = `${title} - ${siteName}`;
  else document.title = siteName;
};

export default setTitle;
